import inlineSVG from "inline-svg";

export const socialMenu = function (el) {
    const footerSocial = el.querySelector(".footer__social");
    if (footerSocial) {
        const els = el
            .querySelector(".footer__social")
            .querySelectorAll("li a");
        for (let i = 0; i < els.length; i += 1) {
            const text = els[i].innerText.toLowerCase();
            els[
                i
            ].innerHTML = `<img src="${window.site_settings.path}/img/${text}.svg" alt="${text}" class="svg">`;
        }

        inlineSVG.init(
            {
                svgSelector: ".footer__social img.svg",
                initClass: "js-inlinesvg",
            },
            function () {
                console.log("All SVGs inlined");
            }
        );
    }
};
